import {
  IModalsService,
  IMODALS_SERVICE,
  INotificationsService,
  INOTIFICATIONS_SERVICE,
  P500UIBaseModal,
} from '@platform500services/p500-ui-kit';
import { Component, Inject, Input } from '@angular/core';
import { ActionsServiceInterface } from '../../services/actions/actions-service.interface';
import { PageServiceInterface } from '../../services/page/page-service.interface';
import { TermsResponse } from '../../../modules/account-protection/account-protection/widgets/terms/terms.response';
import { forkJoin } from 'rxjs';
import { TermsActionConfig } from '../../action-configs/terms/terms.action-config';
import { RbacServiceInterface } from '../../services/rbac/rbac-service.interface';
import { IDataService } from '../../services/data/data-service.interface';
import { Router } from '@angular/router';

@Component({
  templateUrl: './show-terms.modal.html',
})
export class ShowTermsModal extends P500UIBaseModal {
  @Input() docs: TermsResponse['crm_terms'];
  public isLoading = false;
  public get confirm(): boolean {
    return !!this.docs?.some((item) => !item.agreed);
  }

  constructor(
    @Inject(IMODALS_SERVICE) public modalsService: IModalsService,
    @Inject('ActionsServiceInterface') private actionsService: ActionsServiceInterface,
    @Inject(INOTIFICATIONS_SERVICE) private notificationsService: INotificationsService,
    @Inject('PageServiceInterface') private pageService: PageServiceInterface,
    @Inject('IDataService') private dataService: IDataService,
    @Inject('RbacServiceInterface') private rbacService: RbacServiceInterface,
    router: Router
  ) {
    super(modalsService, router);
  }

  public submit(): void {
    const config = new TermsActionConfig(this.dataService, this.rbacService);
    this.isLoading = true;
    const makeRequest = (crm_document_id: number) => this.actionsService.process(config, { crm_document_id }, undefined, {});
    forkJoin(this.docs.map((item) => makeRequest(item.document.id))).subscribe(
      () => {
        this.close();
        this.pageService.refresh();
        this.isLoading = false;
        this.notificationsService.add(
          {
            type: 'success',
            title: $localize`:@@common.success_in:Success In`,
          },
          true
        );
      },
      () => {
        this.isLoading = false;
      }
    );
  }
}
